package com.evoapps.evoshift.data.dto.finance

import kotlinx.serialization.Serializable

@Serializable
data class DailyRecordDto(
    val id: String,
    val rosterId: String,
    val workplaceId: String,
    val date: String,
    val revenue: DailyRevenueDto,
    val laborStats: DailyLaborStatsDto = DailyLaborStatsDto(),
    val costs: DailyCostsDto,
    val efficiency: DailyEfficiencyDto,
    val isLocked: Boolean = false
)

@Serializable
data class DailyLaborStatsDto(
    val planned: LaborSummaryDto = LaborSummaryDto(),
    val actual: LaborSummaryDto = LaborSummaryDto()
)

@Serializable
data class LaborSummaryDto(
    val totalCost: Double = 0.0,
    val totalHours: Double = 0.0,
    val laborPercentage: Double = 0.0
)

@Serializable
data class DailyRevenueDto(
    val planNetto: Double,
    val realBrutto: Double? = null,
    val realNetto: Double? = null,
    val previousYearBrutto: Double? = null,
    val previousYearNetto: Double? = null,
    val fixedRevenue: Double = 0.0,
    val commissionPercent: Double = 0.0,
    val comments: String? = null,
    /** SH-87: the day's ledger revenue items. */
    val otherRevenue: Double = 0.0,
    /** SH-123: MANUAL, CSV or POS (RevenueSource); absent on older records. */
    val source: String? = null,
    /** SH-123: when an import wrote the takings (ISO-8601). */
    val importedAt: String? = null
)

@Serializable
data class DailyCostsDto(
    val plannedHours: Double,
    val actualHours: Double,
    val plannedByContractType: Map<String, Double>, // SystemContractType.name
    val actualByContractType: Map<String, Double>, // SystemContractType.name
    val otherCosts: Double = 0.0,
    /**
     * SH-193: the day's unassigned shifts in the plan: their hours are in plannedHours, openCost
     * (an estimate at openCostPerHour) in the planned labour cost. recalculateRosterFinancials
     * adds openCost to the planned labour.
     */
    val openShifts: Int = 0,
    val openHours: Double = 0.0,
    val openCost: Double = 0.0,
    val openCostPerHour: Double? = null,
    val openRateSource: String? = null
)

@Serializable
data class DailyEfficiencyDto(
    val spmhReal: Double? = null
)
